import * as Sentry from "@sentry/nuxt"

const runtimeConfig = useRuntimeConfig()

if (
  !runtimeConfig.public.e2eTest &&
  import.meta.env.MODE != "test" &&
  !import.meta.dev
) {
  Sentry.init({
    dsn: runtimeConfig.public.sentry.dsn,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // If you don't want to use Session Replay, just remove the line below:
    integrations: [
      Sentry.replayIntegration({
        // Reuse `amp-mask` and `amp-block` that amplitude uses for their replays
        mask: [".amp-mask"],
        block: [".amp-block"],
        blockAllMedia: false,
        maskAllText: false,
      }),
    ],

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
  })
}
